import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export const fetchProducts = async (params = {}) => {
  const { data } = await api.get('/products', { params });
  return data;
};

export const fetchProduct = async (slug) => {
  const { data } = await api.get(`/products/${slug}`);
  return data;
};

export const fetchCollections = async () => {
  const { data } = await api.get('/collections');
  return data;
};

export const fetchCollection = async (slug) => {
  const { data } = await api.get(`/collections/${slug}`);
  return data;
};

export const fetchConfig = async () => {
  const { data } = await api.get('/config');
  return data;
};

export const fetchFaqs = async () => {
  const { data } = await api.get('/faqs');
  return data;
};

export const search = async (q) => {
  const { data } = await api.get('/search', { params: { q } });
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await api.post('/orders', payload);
  return data;
};

export const fetchOrder = async (orderId, params = {}) => {
  const { data } = await api.get(`/orders/${orderId}`, { params });
  return data;
};

export const submitBulkInquiry = async (payload) => {
  const { data } = await api.post('/bulk-inquiries', payload);
  return data;
};

export const submitSupportTicket = async (payload) => {
  const { data } = await api.post('/support-tickets', payload);
  return data;
};

export const createShopifyCheckout = async (items) => {
  const { data } = await api.post('/shopify/checkout', { items });
  return data;
};
